import { Stream } from "./Cell";
import { pct } from "../lib/api";

export const RerankPanel = ({ r }) => {
  const rr = r.rerank;
  if (!rr?.applied) return <Stream testid="rerank-skipped">{"rerank skipped (disabled or no reference photos available)"}</Stream>;
  const byName = Object.fromEntries(rr.candidates.map((c) => [c.name, c]));
  const before = r.predictions_original?.[0]?.scientific_name;
  return (
    <div className="space-y-3" data-testid="rerank-panel">
      <Stream testid="rerank-summary">{`method       : ${rr.method}
top1 before  : ${before}
top1 after   : ${r.predictions[0].scientific_name}
changed_top1 : ${rr.changed_top1 ? "True" : "False"}
best_visual  : ${rr.best_visual == null ? "nan" : rr.best_visual.toFixed(2)}`}</Stream>
      <div className="overflow-x-auto">
        <table data-testid="rerank-table" className="text-[13px] w-full min-w-[640px]">
          <thead><tr className="border-b font-semibold text-right"><th className="px-2 py-1 text-left">candidate</th><th className="px-2 py-1">p (ensemble)</th><th className="px-2 py-1">visual v</th><th className="px-2 py-1">p′ (re-ranked)</th><th className="px-2 py-1 text-left">reference photos · score</th></tr></thead>
          <tbody>
            {r.predictions.map((p, i) => (
              <tr key={p.scientific_name} data-testid={`rerank-row-${i}`} className={`odd:bg-secondary/70 text-right align-middle ${i === 0 ? "font-semibold" : ""}`}>
                <td className="px-2 py-1 text-left italic">{p.scientific_name}</td>
                <td className="px-2 py-1 font-mono">{pct(p.prior_probability)}</td>
                <td className="px-2 py-1 font-mono">{p.visual_score == null ? "—" : p.visual_score.toFixed(2)}</td>
                <td className="px-2 py-1 font-mono">{pct(p.probability)}</td>
                <td className="px-2 py-1"><div className="flex gap-1.5">
                  {(byName[p.scientific_name]?.photos || []).map((ph) => (
                    <div key={ph.url} className="relative">
                      <img src={ph.url} alt="" className={`h-12 w-12 object-cover rounded-sm border ${ph.score >= 60 ? "ring-2 ring-emerald-500" : ""}`} />
                      <span className="absolute bottom-0 right-0 text-[9px] font-mono bg-black/70 text-white px-1 rounded-tl">{ph.score ?? "?"}</span>
                    </div>
                  ))}
                </div></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
